import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

export const getCustomerDetails = createAsyncThunk(
    'customerDetails/getCustomerDetails',
    async ({ customerId, token }, { rejectWithValue }) => {
    const url = `${import.meta.env.VITE_API_BASE_URL}/customers?customerId=${customerId}`;
    const headers = { 'Content-Type': 'application/json', 'auth-token': token };
    const options = { method: 'GET', headers };
    try {
        const response = await fetch(url, options);
        if (!response.ok) {
            const error = await response.json();
            return rejectWithValue({
                message: error.message || `Errore sconosciuto.`
            })
        } else {
            const result = await response.json();
            return result
        }
    } catch (error) {
        return rejectWithValue({
            message: (error instanceof Error) ? error.message : 'Errore di rete. Riprova più tardi.'
        });
    }
})

const customerDetailsSlice = createSlice({
    name: "customerDetails",
    initialState: {
        isLoading: false,
        error: null,
        data: null
    },
    reducers: {

    },
    extraReducers: (builder) => {
        builder
            .addCase(getCustomerDetails.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(getCustomerDetails.rejected, (state, action) => {
                state.data = null;
                state.error = action.payload?.message || "Errore sconosciuto nel caricamento di system details.";
                state.isLoading = false;
            })
            .addCase(getCustomerDetails.fulfilled, (state, action) => {
                state.error = null;
                state.data = action.payload;
                state.isLoading = false;
            })
    }
})

// Selectors
export const selectCustomerDetailsData = (state) => state.customerDetails.data;
export const selectCustomerDetailsIsLoading = (state) => state.customerDetails.isLoading;
export const selectCustomerDetailsError = (state) => state.customerDetails.error;

export default customerDetailsSlice.reducer;